const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabsRoot: {
    borderBottom: '1px solid #ccc',
    backgroundColor: 'rgba(240, 240, 240, 0.5)',
  },
  tabsIndicator: {
    backgroundColor: '#1890ff',
    marginBottom: 0,
  },
  tabRoot: {
    textTransform: 'initial',
    paddingTop: 10,
    fontSize: 16,
    textAlign: 'center',
    fontFamily: 'Arial',
    '&:hover': {
      color: '#3a3a3a',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#1890ff',
      fontWeight: 'bold',
      borderBottom: '1px solid rgba(240, 240, 240, 0.5)',
    },
    '&:focus': {
      color: '#1890ff',
      fontWeight: 'bold',
    },
  },
  tabSelected: {
    borderRight: '1px solid #e0e0e0',
    borderLeft: '1px solid #e0e0e0',
  },
  typography: {
    padding: theme.spacing.unit * 3,
  },
  IconStyle: { width: 31, height: 31 },
});

export default styles;
